import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

const Quick = ({ color = 'icon.blue', fill = 'transparent', ...props }) => (
  <IconBase viewBox='0 0 22 18' {...props}>
    <Path
      d='M5.66948 15.4141H2.92188'
      stroke={color}
      fill={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M3.84136 10.3759H1.09375'
      stroke={color}
      fill={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M5.66948 4.87981H2.92188'
      stroke={color}
      fill={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M13.9219 6.25781V9.92129'
      stroke={color}
      fill={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M12.0859 1.21965H15.7494'
      stroke={color}
      fill={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.54019 9.5148C7.93979 5.90834 11.0571 3.24091 14.4723 3.52913C17.8875
           3.81735 20.4687 6.75469 20.3242 10.1885C20.1797 13.6224 17.361 16.3312
            13.9337 16.33'
      stroke={color}
      fill={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </IconBase>
)

Quick.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Quick
